// extracted by mini-css-extract-plugin
export default {"input":"_2lA8NseVMRTQn9LdLFTvOC"};